var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtotal-row"},[_c('added-to-cart'),_vm._v(" "),_c('sub-total',{attrs:{"action":_vm.action}},[_vm._v("\n        Continue To Cart\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }